<script>
	import formBase from '@_system/components/base/form.vue'
	import expressBox from './box/express.vue'
	import costorderBox from './box/costorder.vue'
	export default {
		extends: formBase,
		name: 'expressstopForm',
		props: {

		},
		render(h) {
			this.$slots.plug = [ 	
				<express-box ref="expressbox" onSubmit = {this.expressboxSubmit} />,
				<costorder-box ref="costorderbox" onSubmit = {this.costorderboxSubmit} />,
			]
			return formBase.render.call(this, h)
		},
		data() {
			return {

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeInit(next){
				next()
			},
			warehouseidChange(e){
				let target = window.systemData.warehouse.find((item)=>{
					return item.id == e
				})
				if(target && target.managerstaffid){
					this.fApi.setValue('warehousemanagerstaffid',JSON.parse(target.managerstaffid))
				}else{
					this.fApi.setValue('warehousemanagerstaffid',null)
				}
			},
			expresssnameButton(){
				this.$refs.expressbox.initList()
				this.$refs.expressbox.box.alertBox()
			},
			expressboxSubmit(e){
				if(e.data){
					this.fApi.setValue('expresssname',e.data.distrName)
					this.fApi.setValue('expresssid',e.data.unitUid)
				}
				
			},
			relationcodeButton(){
				this.$refs.costorderbox.initList()
				this.$refs.costorderbox.box.alertBox()
			},
			costorderboxSubmit(e){
				if(e.data){
					this.fApi.setValue('relationorderid',e.data.id)
					this.fApi.setValue('relationcode',e.data.code)
					this.fApi.setValue('settlement',e.data.amount)
				}
			}
		},
		components: {
			expressBox,
			costorderBox
		}
	}
</script>
